import { Form } from 'react-bootstrap';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useAppSelector } from '@/app/hook';
import { wizardState } from '@/features/bot/botSlice';
import { BotTypeEnum } from '@/utils/BotTypeEnum';

import HintBlock from '../../../common/HintBlock';

type Props = {
  formBuilder: UseFormReturn<any, any>;
};

function BotEditChatbotName({ formBuilder }: Props) {
  const wizard = useAppSelector(wizardState);
  const { t, i18n } = useTranslation();

  return (
    <div className="tw-self-stretch tw-flex-col tw-justify-start tw-items-start tw-gap-5 tw-flex tw-mb-5">
      <div className="tw-self-stretch tw-flex-col tw-justify-start tw-items-start tw-gap-2 tw-flex">
        <div className="tw-self-stretch tw-text-gray-900 tw-text-2xl tw-font-semibold tw-font-['Lexend'] tw-leading-loose">
          {wizard.bot_code === BotTypeEnum.HUMAN_CLONE ? t('Wizard/step1/key10') : t('Wizard/step1/key7')}
        </div>
        <div className="tw-self-stretch tw-text-gray-900 tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight">
          {wizard.bot_code === BotTypeEnum.HUMAN_CLONE ? t('Wizard/step1/key11') : t('Wizard/step1/key8')}
        </div>
      </div>
      <div className="md:tw-max-w-[357px] tw-w-full tw-justify-start tw-items-start tw-gap-2 tw-flex tw-flex-col">
        <Form.Group className="tw-w-full">
          <Form.Control
            isInvalid={!!formBuilder.formState.errors.title}
            maxLength={30}
            {...formBuilder.register('title')}
            className="tw-h-10 tw-px-4 tw-py-2.5 tw-bg-white tw-rounded-md tw-shadow-sm tw-border tw-border-gray-300 tw-justify-start tw-items-center tw-inline-flex"
          />
          <HintBlock texts={['MacBotResponseForm/maxlenght']} />
          <Form.Control.Feedback type="invalid" className="d-block font-poppins">
            {formBuilder?.formState?.errors?.title?.message as string}
          </Form.Control.Feedback>
        </Form.Group>
      </div>
    </div>
  );
}

export default BotEditChatbotName;
